<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title>
        Trigger Email Notification to {{ selectedApplicants.length }}
        {{ selectedApplicants.length == 1 ? "Applicant" : "Applicants" }}
        <v-spacer></v-spacer>
        <v-btn small class="error--text" icon @click="$emit('closeDialog')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="mt-2">
        <v-row>
          <v-col cols="7">
            <v-col cols="12">
              <v-menu
                v-model="paymentDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedPaymentEndDate"
                    label="Payment End Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    outlined
                    dense
                    hide-details
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="triggerEmail.payment_end_date"
                  no-title
                  :min="minDate"
                  @input="paymentDatePicker = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="triggerEmail.subject"
                label="Email Subject"
                dense
                hide-details
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="triggerEmail.description"
                label="Body"
                outlined
                hide-details
                dense
              ></v-textarea>
            </v-col>
          </v-col>
          <v-col cols="5">
            Preview:
            <v-card outlined class="pa-4">
              <h4 style="color: #3f51b5; margin-bottom: 5px">
                <em>Greetings from SASTRA Deemed University!</em>
              </h4>

              <p>Dear *applicant_name*,</p>
              <p>
                {{ triggerEmail.description || "........." }}
              </p>
              <p>
                Last date for the payment:
                {{ formattedPaymentEndDate || "*payment_end_date*" }}
              </p>

              <div style="font-size: 10px; color: #666">
                <p>Regards,<br />SASTRA Online Education</p>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="
            !triggerEmail.subject ||
            !triggerEmail.description ||
            !triggerEmail.payment_end_date
          "
          @click="$emit('trigger', triggerEmail)"
          >Send Email</v-btn
        >
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
export default {
  props: {
    selectedApplicants: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      paymentDatePicker: false,
      triggerEmail: {
        payment_end_date: null,
        subject: "",
        description: "",
      },
    };
  },
  computed: {
    formattedPaymentEndDate() {
      const date = this.triggerEmail?.payment_end_date;
      if (!date) return "";
      const [year, month, day] = date.split("-");
      this.triggerEmail.payment_end_date = `${year}-${month}-${day}`;
      return `${day}-${month}-${year}`;
    },
  },
  created() {},
  methods: {},
};
</script>

<style scoped></style>
